import Debug from 'debug';
import { call, put, takeLatest } from 'redux-saga/effects';

import { firestore } from '../../../firebase';

import { FETCH_USER_RESERVATION, fetchUserReservation } from '../actions';

const debug = Debug('sgwa:client-admin:store:reservations:sagas:fetchUserReservation');

export function* fetchReservationSaga({ payload: permitNumber }) {
  debug('Saga called', permitNumber);

  try {
    let reservationData;

    const sanGRef = firestore.doc('san_gorgonio/main').collection('reservations').doc(permitNumber);
    const sanGReservation = yield call([sanGRef, sanGRef.get]);

    const sanGData = sanGReservation.data();
    reservationData = sanGData;

    if (!reservationData) {
      debug('No reservation found for San Gorgonio, checking Cucamonga');

      const cucaRef = firestore.doc('cucamonga/main').collection('reservations').doc(permitNumber);
      const cucaReservation = yield call([cucaRef, cucaRef.get]);

      const cucaData = cucaReservation.data();
      reservationData = cucaData;
    }

    if (!reservationData) throw Error('No reservation found');

    debug('Reservation found for document', reservationData);

    yield put(fetchUserReservation.success(reservationData));
  } catch (e) {
    debug('Saga error', e.message);
    yield put(fetchUserReservation.error(e.message));
  }
}

export default function* () {
  yield takeLatest(FETCH_USER_RESERVATION.PENDING, fetchReservationSaga);
}
